import React from "react";

export type SelectedPLState = {
    selectedPL:string
    // setSelectedPL:(s:string)=>void
}

export const SelectedPLContext = React.createContext<SelectedPLState>({selectedPL:''})
